/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box } from "@mui/material";
import React from "react";

import FarmlandsProLogoColored from "../assets/images/FarmlandsProLogoColored.svg?react";
import { AppWithoutLayout, AppWithoutLayoutContainer } from "../components/layout/AppWithoutLayout";

export const BlockingPage: React.FC<{
  children: React.ReactNode | React.ReactNode[];
  "data-testid": string;
}> = (props) => {
  return (
    <AppWithoutLayoutContainer data-testid={props["data-testid"]}>
      <AppWithoutLayout>
        <Box mb={2} mt={2}>
          <FarmlandsProLogoColored width={170} height={"31px"} />
        </Box>
        {props.children}
      </AppWithoutLayout>
    </AppWithoutLayoutContainer>
  );
};
